module.exports = __webpack_public_path__ + "img/xero-connect-blue-hover.34d852b5.png";